import React, { Component } from "react";

import './Divider.css'

export class Divider extends Component {
    constructor(props) {
        super(props);

        this.state = {
            active: false,
        }
    }
    render() {
        return (
            <div className="divider">
            </div>
        );
    }
}
    